import { render, staticRenderFns } from "./TabFiles.vue?vue&type=template&id=5091641a&"
import script from "./TabFiles.vue?vue&type=script&lang=js&"
export * from "./TabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports